

export default (function () {   

    var init = function () {
        const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

        if ($navbarBurgers.length < 1) {
            return;
        }
          
        $navbarBurgers.forEach(el => {
            el.addEventListener('click', () => {
                const target = el.dataset.target;
                const $target = document.getElementById(target);               
                el.classList.toggle('is-active');
                $target.classList.toggle('is-active');
            });
        });
    }; 
   

    return {
        init: init
    };
})();


